import {
  useMediaQuery,
  Grid,
  TextField,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  makeStyles,
  useTheme,
  Container,
  Link as MuiLink,
  FormHelperText,
  Checkbox,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import ButtonSp from '../components/ui/ButtonSp'
import TextCollapseSp from '../components/ui/TextCollapseSp'
import { useForm, Controller } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'
import { useRef, useState } from 'react'
import SuccessModal from '../components/common/SuccessModal'
import clsx from 'clsx'
import Axios from 'axios'
import { scroller } from 'react-scroll'
import ProtectedByRecaptcha from '../components/common/ProtectedByRecaptcha'
import getConfig from 'next/config'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const { publicRuntimeConfig } = getConfig()

const proPrice = 999

const useStyles = makeStyles((theme) => ({
  title: {
    ...theme.homeStyle.title,
  },
  topic: {
    ...theme.homeStyle.topic,
  },
  desc: {
    ...theme.homeStyle.desc,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  heroSec: {
    // mobile
    background:
      'linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.7) 38%, rgba(0,0,0,0) 85%), url("/static/img/pro/pro-hero-mobile.jpg") no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'right',
    padding: `${theme.spacing(1)}px ${theme.spacing(0)}px`,
    minHeight: 550,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // tablet + desktop
    [theme.breakpoints.up('sm')]: {
      background:
        'linear-gradient(to right,rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0)), url("/static/img/pro/pro-heroimg-desktop.jpg") no-repeat',
      backgroundColor: 'black',
      backgroundSize: 'cover',
      padding: `${theme.spacing(1)}px ${theme.spacing(5)}px`,
      minHeight: theme.homeStyle.heroImageHeightDesktop,
      justifyContent: 'center',
    },
    // tablet
    [theme.breakpoints.only('sm')]: {
      background:
        'linear-gradient(to right,rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), url("/static/img/pro/pro-heroimg-desktop.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    // very large desktop
    [theme.breakpoints.up('xl')]: {
      background:
        'linear-gradient(to right,rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)), url("/static/img/pro/pro-heroimg-desktop.jpg") no-repeat',
      backgroundColor: 'black',
      backgroundSize: '1440px 400px',
      backgroundPosition: 'right',
    },
  },
  registerButton: {
    ...theme.homeStyle.button,
    marginTop: theme.spacing(2),
  },
  heroTitle: {
    ...theme.homeStyle.heroTitle,
    margin: 0,
  },
  heroSubtitle: {
    ...theme.homeStyle.heroSubtitle,
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px`,
    [theme.breakpoints.down('xs')]: {
      margin: `${theme.spacing(1)}px 0`,
    },
  },
  heroText: {
    marginBottom: theme.spacing(2),
    width: '100%',
    color: 'white',
    '& h4': {
      fontWeight: 400,
      fontSize: 16,
      margin: `${theme.spacing(0.5)}px 0`,
    },
  },
  benefits: {
    ...theme.homeStyle.section,
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  benefitsGrid: {
    width: '100%',
  },
  benefitBox: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(1)}px 0`,
    },
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(3)}px`,
    },
  },
  benefitsImg: {
    width: '100%',
    maxWidth: 160,
    [theme.breakpoints.up('sm')]: {
      width: 120,
    },
  },
  becomePro: {
    ...theme.homeStyle.section,
    textAlign: 'center',
    backgroundColor: '#fafafa',
    '& img': {
      width: '100%',
      maxWidth: 140,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  step: {
    color: '#404041',
    fontSize: 16,
    textAlign: 'left',
    fontWeight: 400,
    margin: `${theme.spacing(1)}px 0`,
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
      fontSize: 16,
    },
  },
  formSec: {
    ...theme.homeStyle.section,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  lowerForm: {
    width: '100%',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  radio: {
    margin: `${theme.spacing(2)}px 0`,
  },
  faqSec: {
    ...theme.homeStyle.section,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  faqWrap: {
    maxWidth: 1000,
    textAlign: 'left',
  },
  field: {
    width: '100%',
  },
  fieldBox: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  formBtn: {
    ...theme.homeStyle.button,
    alignSelf: 'center',
    marginTop: 0,
  },
  titleNoMarginTop: {
    marginTop: 0,
  },
  protected: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}))

const ProPage = () => {
  const theme = useTheme()
  const { register, handleSubmit, control, errors } = useForm()
  const recaptchaRef = useRef(null)
  const [isCaptchaExecuting, setCaptchaExecuting] = useState(false)
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false)
  const [isErrorModalOpen, setErrorModalOpen] = useState(false)

  const { t } = useTranslation('pro')

  const scrollToForm = () => {
    scroller.scrollTo('register-form', {
      smooth: 'easeInOutQuart',
      offset: -100,
    })
  }

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()

  const faqData = [
    {
      title: t('faq-detail.who-shippop-pro.q'),
      desc: t('faq-detail.who-shippop-pro.a'),
    },
    {
      title: t('faq-detail.difference.q'),
      desc: t('faq-detail.difference.a'),
    },
    {
      title: t('faq-detail.fee.q', { proPrice }),
      desc: t('faq-detail.fee.a', { proPrice }),
    },
    {
      title: t('faq-detail.payment.q'),
      desc: t('faq-detail.payment.a'),
    },
  ]

  const benefits = [
    {
      img: 'pro_promotion.svg',
      title: t('features.special-promotion.title'),
      desc: t('features.special-promotion.desc'),
    },
    {
      img: 'pro_postpaid.svg',
      title: t('features.monthly-bill.title'),
      desc: t('features.monthly-bill.desc'),
    },
    {
      img: 'pro_tax.svg',
      title: t('features.tax.title'),
      desc: t('features.tax.desc'),
    },
    {
      img: 'pro_weight.svg',
      title: t('features.without-dimension.title'),
      desc: t('features.without-dimension.desc'),
    },
    {
      img: 'pro_course.svg',
      title: t('features.free-training.title'),
      desc: t('features.free-training.desc'),
    },
    {
      img: 'pro_api.svg',
      title: t('features.api.title'),
      desc: t('features.api.desc'),
    },
  ]

  const steps = [
    ['pro_step1.svg', t('steps.step1')],
    ['pro_step2.svg', t('steps.step2')],
    ['pro_step3.svg', t('steps.step3')],
  ]

  const fields = [
    {
      label: t('form.name'),
      name: 'name',
      type: 'text',
      placeholder: t('form.name-p'),
    },
    {
      label: t('form.email'),
      name: 'email',
      type: 'text',
      placeholder: t('form.email-p'),
    },
    {
      label: t('form.phone'),
      name: 'phone',
      type: 'number',
      placeholder: t('form.phone-p'),
    },
    {
      label: t('form.line'),
      name: 'line',
      type: 'text',
      placeholder: t('form.line-p'),
    },
    {
      label: t('form.time'),
      name: 'time',
      type: 'select',
      choices: [
        [1, '9:00 - 12:00'],
        [2, '13:00 - 17:00'],
      ],
    },
    {
      label: t('form.shipment-month'),
      name: 'shippingPerMonth',
      type: 'number',
      placeholder: t('form.shipment-month-p'),
    },
    {
      label: t('form.store'),
      name: 'category',
      type: 'select',
      choices: [
        ['เสื้อผ้า แฟชั่น', 'เสื้อผ้า แฟชั่น'],
        ['เครื่องประดับ', 'เครื่องประดับ'],
        ['สุขภาพ', 'สุขภาพ'],
        ['ความงาม', 'ความงาม'],
        ['แม่และเด็ก', 'แม่และเด็ก'],
        ['ของเล่นและเกมส์', 'ของเล่นและเกมส์'],
        ['หนังและบันเทิง', 'หนังและบันเทิง'],
        ['ไลฟ์สไตล์', 'ไลฟ์สไตล์'],
        ['หนังสือและของสะสม', 'หนังสือและของสะสม'],
        ['กล้องและอุปกรณ์เสริม', 'กล้องและอุปกรณ์เสริม'],
        ['เครื่องใช้ไฟฟ้า', 'เครื่องใช้ไฟฟ้า'],
        ['โทรศัพท์และคอมพิวเตอร์', 'โทรศัพท์และคอมพิวเตอร์'],
        ['เฟอร์นิเจอร์ของตกแต่ง', 'เฟอร์นิเจอร์ของตกแต่ง'],
        ['ยานยนต์และอุปกรณ์', 'ยานยนต์และอุปกรณ์'],
        ['สินค้าและอุปกรณ์การเกษตร', 'สินค้าและอุปกรณ์การเกษตร'],
        ['อุปกรณ์การแพทย์', 'อุปกรณ์การแพทย์'],
        ['ร้านยาและเวชภัณฑ์', 'ร้านยาและเวชภัณฑ์'],
        ['วัสดุและอุปกรณ์ก่อสร้าง', 'วัสดุและอุปกรณ์ก่อสร้าง'],
        ['อาหารและเครื่องดื่ม', 'อาหารและเครื่องดื่ม'],
        ['อื่นๆ', 'อื่นๆ'],
      ],
    },
    {
      label: t('form.url'),
      name: 'url',
      type: 'text',
      placeholder: t('form.url-p'),
    },
  ]

  const renderRules = (fieldName) => {
    // the fields that only required
    if (['name', 'time', 'shippingPerMonth', 'category'].includes(fieldName)) {
      return { required: true }
    }
    if (fieldName === 'email') {
      return { required: true, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }
    }
    if (fieldName === 'phone') {
      return { required: true, pattern: /^0\d{8,9}$/ }
    }
    if (fieldName === 'line') {
      return { validate: (value) => value === '' || /^@?\w+$/.test(value) }
    }
    if (fieldName === 'url') {
      return {
        validate: (value) =>
          value === '' ||
          /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(
            value
          ),
      }
    }
    return {}
  }

  const renderErrorText = (fieldName, fieldLabel) => {
    if (['name', 'shippingPerMonth'].includes(fieldName)) {
      return `${t('form.please-fill')} ${fieldLabel}`
    }
    if (['time', 'category'].includes(fieldName)) {
      return `${t('form.please-select')} ${fieldLabel}`
    }
    if (['email', 'phone', 'line', 'url'].includes(fieldName)) {
      return `${t('form.please-fill')} ${fieldLabel} ${t('form.correctly')}`
    }
    return ''
  }

  const renderField = (field) => {
    let fieldJSX
    if (field.type === 'text' || field.type === 'number') {
      fieldJSX = (
        <TextField
          name={field.name}
          label={field.label}
          type={field.type}
          variant="outlined"
          className={classes.field}
          inputRef={register(renderRules(field.name))}
          error={errors[field.name]}
          helperText={
            errors[field.name] && renderErrorText(field.name, field.label)
          }
          placeholder={field.placeholder || ''}
        />
      )
    } else if (field.type === 'select') {
      fieldJSX = (
        <FormControl variant="outlined" fullWidth>
          <InputLabel error={errors[field.name]}>{field.label}</InputLabel>
          <Controller
            as={
              <Select
                variant="outlined"
                label={field.label}
                fullWidth
                native
                error={errors[field.name]}
              >
                <option value="" disabled />
                {field.choices.map(([name, label]) => (
                  <option value={name} key={name}>
                    {label}
                  </option>
                ))}
              </Select>
            }
            control={control}
            name={field.name}
            defaultValue={''}
            rules={renderRules(field.name)}
          />
          {errors[field.name] && (
            <FormHelperText error>
              {renderErrorText(field.name, field.label)}
            </FormHelperText>
          )}
        </FormControl>
      )
    }
    return (
      <Grid item xs={12} sm={6} key={field.name} className={classes.fieldBox}>
        {fieldJSX}
      </Grid>
    )
  }

  const renderHeroSection = () => {
    return (
      <div className={classes.heroSec}>
        <Container>
          <div className={classes.heroText}>
            <h1 className={classes.heroTitle}>SHIPPOP PRO</h1>
            <h2 className={classes.heroSubtitle}>
              {t('hero.sub-1')}
              {isMobile ? <br /> : ''}
              {t('hero.sub-2')}
            </h2>
            <h4>{t('hero.price', { price: proPrice })}</h4>
            <h4>
              {t('hero.price-free')}
              <span
                style={{ color: 'red', fontWeight: 500, whiteSpace: 'nowrap' }}
              >
                {t('hero.free')}
              </span>
            </h4>
            <ButtonSp
              className={classes.registerButton}
              onClick={() => scrollToForm()}
            >
              {t('hero.join')}
            </ButtonSp>
          </div>
        </Container>
      </div>
    )
  }

  const renderBenefitBox = (benefit, index) => (
    <Grid
      item
      container
      xs={12}
      md={6}
      direction="row"
      justify="space-evenly"
      alignItems="center"
      key={index}
      className={classes.benefitBox}
    >
      <Grid
        item
        container
        xs={12}
        sm={4}
        md={3}
        direction="row"
        justify="center"
        alignItems="center"
        style={{ textAlign: 'center' }}
      >
        <img
          src={`/static/img/pro/${benefit.img}`}
          alt={benefit.title}
          className={classes.benefitsImg}
        />
      </Grid>
      <Grid item xs={12} sm={8} md={9}>
        <h4 className={classes.topic}>{benefit.title}</h4>
        <h5 className={classes.desc}>{benefit.desc}</h5>
      </Grid>
    </Grid>
  )

  const renderBenefits = () => (
    <Container>
      <div className={classes.benefits}>
        <h1 className={classes.title}>{t('shippop-pro-privilege')}</h1>
        <Grid
          container
          direction={isMobile ? 'column' : 'row'}
          alignItems="center"
          className={classes.benefitsGrid}
        >
          {isMobile
            ? benefits.map(renderBenefitBox)
            : [
                benefits[0],
                benefits[3],
                benefits[1],
                benefits[4],
                benefits[2],
                benefits[5],
              ].map(renderBenefitBox)}
        </Grid>
      </div>
    </Container>
  )

  const renderStepBox = (step, index) => (
    <Grid
      item
      container
      xs={12}
      sm={3}
      direction="row"
      alignItems="center"
      justify="center"
      key={index}
    >
      <Grid item xs={3} sm={12}>
        <img src={`/static/img/pro/${step[0]}`} alt={step[1]} />
      </Grid>
      <Grid item xs={9} sm={12}>
        <h4 className={classes.step}>{step[1]}</h4>
      </Grid>
    </Grid>
  )

  const renderBecomePro = () => (
    <div className={classes.becomePro}>
      <Container>
        <h1 className={clsx(classes.title, classes.titleNoMarginTop)}>
          {t('few-steps')}
        </h1>
        <Grid
          container
          direction={isMobile ? 'column' : 'row'}
          justify="space-evenly"
        >
          {steps.map(renderStepBox)}
        </Grid>
      </Container>
    </div>
  )

  const renderFaq = () => (
    <div className={classes.faqSec}>
      <h1 className={classes.title}>{t('faq')}</h1>
      <Container className={classes.faqWrap}>
        <TextCollapseSp data={faqData} />
      </Container>
    </div>
  )

  const onSubmit = handleSubmit(async (data) => {
    try {
      setCaptchaExecuting(true)
      const token = await recaptchaRef.current.executeAsync()
      const {
        data: { success: captchaSuccess },
      } = await Axios.post('/api/recaptcha/validate', { recaptchaToken: token })
      if (captchaSuccess) {
        let newData = { ...data }
        if (data.shop) newData.shop = 'interested'
        else newData.shop = 'not-interested'
        const {
          data: { status },
        } = await Axios.post('/api/pro/apply', data)
        if (status === 'success') setSuccessModalOpen(true)
        else setErrorModalOpen(true)
      } else {
        setErrorModalOpen(true)
      }
      recaptchaRef.current.reset()
    } catch (err) {
      setErrorModalOpen(true)
    } finally {
      setCaptchaExecuting(false)
      recaptchaRef.current.reset()
    }
  })

  return (
    <>
      <Layout
        title="SHIPPOP PRO - ส่งพัสดุ ส่งเยอะ ส่งถูกลง เหมือนมีผู้ช่วยส่วนตัว"
        keywords="ส่งของเยอะ, ส่งของ, จ่ายรายเดือน, ส่งพัสดุ, Business"
        description="ลูกค้า SHIPPOP PRO ทำให้การส่งของ ส่งของจำนวนมากให้เป็นเรื่องง่าย  จ่ายค่าส่งพัสดุเป็นรายเดือน ราคาส่งที่ถูกสุด มากกว่าใคร พร้อมผู้ช่วยดูแลส่วนตัว ตามพัสดุให้คุณ"
      >
        <div className={classes.root}>
          {renderHeroSection()}
          {renderBenefits()}
          {renderBecomePro()}
          <form onSubmit={onSubmit}>
            <div className={classes.formSec} id="register-form">
              <Container>
                <h1 className={classes.title}>{t('form.title')}</h1>
                <Grid container spacing={0}>
                  {fields.map((field) => renderField(field))}
                </Grid>
                <div className={classes.lowerForm}>
                  <FormControlLabel
                    style={{ alignSelf: 'flex-start' }}
                    control={
                      <Controller
                        render={(props) => (
                          <Checkbox
                            onChange={(e) => props.onChange(e.target.checked)}
                            checked={props.value}
                            color="primary"
                          />
                        )}
                        control={control}
                        name="shop"
                      />
                    }
                    label={
                      <>
                        {/* {t('form.interested-in-shop')}&nbsp;&nbsp;&nbsp;&nbsp; */}
                        สนใจเปิดแฟรนไชส์ ร้านรับฝาก SHIPPOP
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <MuiLink href="http://shippop.shop" target="_blank">
                          {t('form.read-more')}
                        </MuiLink>
                      </>
                    }
                    className={classes.radio}
                  />
                  <ProtectedByRecaptcha className={classes.protected} />
                  <ButtonSp
                    className={classes.formBtn}
                    type="submit"
                    loading={isCaptchaExecuting}
                  >
                    {t('form.submit')}
                  </ButtonSp>
                </div>
              </Container>
            </div>
            <ReCAPTCHA
              sitekey={publicRuntimeConfig.recaptcha2Key}
              ref={recaptchaRef}
              size="invisible"
              badge="bottomleft"
            />
          </form>
          {renderFaq()}
        </div>
      </Layout>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        setOpen={setSuccessModalOpen}
        title={t('form.success-modal-title')}
        subtitle={t('form.success-modal-subtitle')}
      />
      <SuccessModal
        type="error"
        isOpen={isErrorModalOpen}
        setOpen={setErrorModalOpen}
        title={t('form.error-modal-title')}
        subtitle={t('form.error-modal-subtitle')}
      />
    </>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'pro',
    ])),
  },
})

export default ProPage
